/** Firm contact details — keep in sync with client/public/jblassets/contact info.md */
export const contactInfo = {
  firmName: 'Jones & Booth',
  /** Legal name shown in footer copyright */
  copyrightName: 'Jones Booth Law',
  addressLine1: '2475 Northwinds Parkway, Suite 200',
  addressLine2: 'Alpharetta, GA 30009',
  email: 'admin@jonesboothlaw.com',
  phone: '470-359-9972',
  phoneHref: 'tel:+14703599972',
  emailHref: 'mailto:admin@jonesboothlaw.com',
};
